import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import loginReducer from './login/data/reducer';
import loginSaga from './login/data/sagas';
import registerReducer from './register/data/reducer';
import registerSaga from './register/data/sagas';
import resetPasswordReducer from './resetPassword/data/reducer';
import resetPasswordSaga from './resetPassword/data/sagas';
import routes from './routes';
import setPasswordReducer from './setPassword/data/reducer';
import setPasswordSaga from './setPassword/data/sagas';
import signUpPageReducer from './signUp/data/reducer';
import signUpPageSaga from './signUp/data/sagas';
import ssoReducer from './sso/data/reducer';
import ssoSaga from './sso/data/sagas';
import twoFactorAuthenticationReducer from './twoFactorAuthentication/data/reducer';
import twoFactorAuthenticationSaga from './twoFactorAuthentication/data/sagas';

const reducer = combineReducers({
  login: loginReducer,
  sso: ssoReducer,
  registration: registerReducer,
  setPassword: setPasswordReducer,
  resetPassword: resetPasswordReducer,
  signUpPage: signUpPageReducer,
  twoFactorAuthentication: twoFactorAuthenticationReducer,
});

const saga = function* () {
  yield all([
    loginSaga(),
    ssoSaga(),
    registerSaga(),
    setPasswordSaga(),
    resetPasswordSaga(),
    signUpPageSaga(),
    twoFactorAuthenticationSaga(),
  ]);
};

export { reducer, saga, routes };
